// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__przOL","productName":"Table_productName__381I7"};